<template>
    <div class="text-center">
      <v-dialog persistent v-model="visible" width="800">
        <v-card class="not-margin pt-0 pr-0 pl-0">
          <v-toolbar dark color="primary">
            <div class="text-center">
              <v-icon>mdi-eye</v-icon> Visualizar Formação
            </div>
          </v-toolbar>
          <div class="container dialog">
            <v-row class="justify-center mt-7">
              <v-col cols="8">
                <v-text-field
                  :value="content.formacao"
                  label="Formação"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :value="content.cargaHoraria"
                  label="Carga Horária"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="justify-center mt-7">
              <v-col cols="8">
                <v-text-field
                  :value="content.localRealizacao"
                  label="Local de Realização"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :value="$formatarData(content.dataRealizacao)"
                  label="Data de Realização"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
            <v-col cols="12">
              <span class="small">Instrutor(es)</span>
              <div class="instrutores-box">
                <v-chip-group active-class="primary--text" column>
                  <v-chip v-for="instrutor in content.listaInstrutores" :key="instrutor.id">
                    {{ instrutor.nome }}
                  </v-chip>
                </v-chip-group>
              </div>
            </v-col>
          </v-row>
          </div>
          <div class="btn-group text-center">
            <v-btn color="primary" @click="$emit('onClose')">
              Fechar
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import { DialogProps } from '~/commons/classes/dialog-props';
  import { ListaPresenca } from "~/commons/classes/lista-presenca";
  
  export default {
    props: new DialogProps(ListaPresenca),
  }
  </script>
  <style scoped>
  .instrutores-box {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    margin-top: 10px;
  }
  </style>